import React, { useState, useEffect } from "react";

export const svg = `<svg viewBox="0 0 28 28"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.825 13.72a1.654 1.654 0 0 0-1.65 0l-3.35 1.928c-.51.294-.825.837-.825 1.424v3.856c0 .587.314 1.13.825 1.424l3.35 1.928c.51.293 1.14.293 1.65 0l3.35-1.928c.51-.294.825-.837.825-1.424v-3.856c0-.587-.314-1.13-.825-1.424l-3.35-1.928Zm12 0a1.654 1.654 0 0 0-1.65 0l-3.35 1.928c-.51.294-.825.837-.825 1.424v3.856c0 .587.314 1.13.825 1.424l3.35 1.928c.51.293 1.14.293 1.65 0l3.35-1.928c.51-.294.825-.837.825-1.424v-3.856c0-.587-.314-1.13-.825-1.424l-3.35-1.928Zm-6-10.5a1.654 1.654 0 0 0-1.65 0l-3.35 1.928C9.315 5.442 9 5.985 9 6.572v3.856c0 .587.314 1.13.825 1.424l3.35 1.928c.51.293 1.14.293 1.65 0l3.35-1.928c.51-.294.825-.837.825-1.424V6.572c0-.587-.314-1.13-.825-1.424l-3.35-1.928Z"></path></svg>`;

const contentRegExp = /<svg(.*?)>(.*?)<\/svg>/s;
const attrRegExp = /(.*?)="(.*?)"/;
const splitAttrExp = /[\w-]+="[^"]*"/g;

const attributeMap = {
  viewbox: "viewBox",
  class: "className",
};

let instanceId = 0;

function Icon(props) {
  const [, attrs, content] = svg.match(contentRegExp);

  const svgAttributes = {};

  for (const stringAttr of attrs.trim().match(splitAttrExp)) {
    let [, key, value] = stringAttr.match(attrRegExp);
    if (key in attributeMap) key = attributeMap[key];
    svgAttributes[key] = value;
  }

  const [obj, setObj] = useState({ svgAttributes, __html: content });

  // On the client, unique IDs are necessary per instance.
  // We will use the fact that React SSR does not run effects!
  useEffect(() => {
    const ids = svg.matchAll(/id="(.*?)"/gm);
    let html = obj.__html;

    for (const [match, id] of ids) {
      const uniqueID = `${id}-${instanceId}`;
      html = html
        .replace(match, 'id="' + uniqueID + '"')
        .replaceAll(`url(#${id})`, `url(#${uniqueID})`)
        .replaceAll(`"#${id}"`, `"#${uniqueID}"`);
    }

    setObj({ svgAttributes, __html: html });

    instanceId++;
  }, []);

  return (
    <svg
      dangerouslySetInnerHTML={obj}
      {...obj.svgAttributes}
      {...props}
    />
  );
}

export default Object.assign(Icon, { svg });
